import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import NotFound from 'pages/not-found'
import routes from 'pages/routes'
import { useLanguage } from 'app/contexts/language'
import { CookieName, userTypeEnum } from 'app/shared/enums'
import { langs } from 'app/shared/definitions'
import { DEFAULT_LANGUAGE } from 'app/shared/constants'
import { enforceValidSession, getUserRole } from 'app/functions/session'

const Router: React.FunctionComponent = () => {
  let [languageContext, languageState] = useLanguage()
  const validLang = langs.filter((lang) => lang.value === languageState).length
  if (validLang <= 0) {
    if (
      localStorage.getItem(CookieName.Language) &&
      langs.filter(
        (lang) => lang.value === localStorage.getItem(CookieName.Language)
      ).length > 0
    ) {
      languageContext.set(
        localStorage.getItem(CookieName.Language) || DEFAULT_LANGUAGE
      )
      window.location.href = `/${localStorage.getItem(CookieName.Language)}`
    } else {
      languageContext.set(DEFAULT_LANGUAGE)
      window.location.href = `/${DEFAULT_LANGUAGE}`
    }
  }
  // Token'da geçerli bir rol claim'i yoksa oturum sonlandırılır;
  // localStorage'daki bir değere geri düşülmez
  enforceValidSession()

  const userRole: any = getUserRole()
  const allowedPathsForIktm = [
    '/signout',
    '/signin',
    '/facility-informations-city-directors',
    '/facility-iktm/detail/',
    '/hotel-certificate/update/',
  ]
  const allowedPathsForVisualContent = ['/signout', '/signin', '/work-list']
  const superAdminOnlyPaths = ['/carbon-emission-factor']
  const blockedPathsForCallCenter = [
    '/request-approval',
    '/approval-audit',
    '/transfer-request',
    '/audit-list',
    '/self-assessment',
    '/gstc-dictionary-list',
  ]

  return (
    <BrowserRouter basename={languageState} key={languageState}>
      <Switch>
        {routes
          .filter(({ path }: any) => {
            if (
              userRole !== userTypeEnum.SuperAdmin &&
              superAdminOnlyPaths.some((adminPath) => path.includes(adminPath))
            ) {
              return false
            }
            if (
              userRole === userTypeEnum.CallCenter &&
              blockedPathsForCallCenter.some((blockedPath) =>
                path.includes(blockedPath)
              )
            ) {
              return false
            }
            if (userRole === userTypeEnum.IKTMUser) {
              return allowedPathsForIktm.some((allowedPath) =>
                path.includes(allowedPath)
              )
            } else if (userRole === userTypeEnum.VisualContentEditor) {
              return allowedPathsForVisualContent.some((allowedPath) =>
                path.includes(allowedPath)
              )
            }
            return true
          })
          .map(({ component: Page, path, ...route }, index) => (
            <Route
              exact
              key={index}
              render={(props) => <Page {...props} />}
              path={path}
              {...route}
            />
          ))}
        {userRole === userTypeEnum.IKTMUser && (
          <Route
            path="*"
            render={() => (
              <Redirect to="/facility-informations-city-directors" />
            )}
          />
        )}
        {userRole === userTypeEnum.VisualContentEditor && (
          <Route path="*" render={() => <Redirect to="/work-list" />} />
        )}
        {userRole !== userTypeEnum.IKTMUser && (
          <Route path="*" component={NotFound} />
        )}
      </Switch>
    </BrowserRouter>
  )
}

export default Router
